module.exports = __webpack_public_path__ + "img/icon_will.d29dc9db.svg";